<template>
    <v-container>
        <v-card style="background-color:transparent !important;">
            <v-card-title class="justify-center primary">
                <v-toolbar-title id="titulocard">Movimientos</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon>mdi-text-box-multiple-outline</v-icon>
            </v-card-title>
            <v-divider></v-divider>
            <div class="tables-basic mt-3" :class="['p-3','text-black']">
                <template>
                    <div>
                        <v-data-table
                            :headers="encabezado"
                            :items="datos"
                            :items-per-page="20"
                            class="elevation-1"
                            no-data-text="No hay datos disponibles"
                            :footer-props="{
                                'items-per-page-options': [20, 50, 100],
                                'items-per-page-text':'Registros por página'
                            }"
                        >
                        <template v-slot:[`item.Esid`]="{item}">
                            <v-icon v-if="item.Esid == 7" color="green">mdi-lock-open-variant</v-icon>
                            <v-icon v-if="item.Esid == 8" color="red">mdi-lock</v-icon>
                        </template>
                        </v-data-table>
                    </div>
                </template>
            </div>
        </v-card>
    </v-container>
</template>


<script>
    import {mapActions, mapState} from 'vuex'
    import Seguimientos from '@/services/GestoriaDoc/Seguimientos.service.js';

    export default {
        data: function(){
            return{
                encabezado: [
                    { text: 'T.P', value: 'Esid',class: "text title" },
                    { text: 'Fecha', value: 'Exfecha', class: "text title"},
                    { text: 'Fecha abo', value: 'Exfechaabo', class: "text title"},
                    { text: 'Tipo', value: 'Cegrupo', class: "text title"},
                    { text: 'Concepto', value: 'Ceconcepto', class: "text title"},
                    { text: 'Resp.', value: 'Exresp', class: "text title"},
                    { text: 'Observaciones', value: 'Exobs', class: "text title"},
                    { text: 'Usuario', value: 'Uslogin', class: "text title"},
                ],
                datos:[],
                movimiento:[],
                movimientosData: [],
            }
        },
        props:[],
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE :{
            get() {
                return this.drawer
            },
            }
        },
        mounted(){
            this.datosSeguimiento()
        },
        methods: {
            datosSeguimiento(){
                Seguimientos.Movimientos(this).then(data => {
                    let auxMovimientosReporte = data;
                    for (let i in auxMovimientosReporte){
                        for (const [key, value] of Object.entries(auxMovimientosReporte[i])) {
                            if(typeof value == "object"){ auxMovimientosReporte[i][key] = "" } else { auxMovimientosReporte[i][key] = value.toString()}
                        }
                    }
                    this.movimientosData = auxMovimientosReporte;
                    this.datos=[];
                    this.movimiento=[];
                    for (let i in this.movimientosData) {
                        if(this.movimientosData.length > 0){
                            this.movimiento[i] = Object.assign({}, {
                                Esid: this.movimientosData[i].Esid,
                                Exfecha: this.movimientosData[i].Exfecha,
                                Exfechaabo: this.movimientosData[i].Exfechaabo,
                                Cegrupo: this.movimientosData[i].Cegrupo,
                                Ceconcepto: this.movimientosData[i].Ceconcepto,
                                Exresp: this.movimientosData[i].Exresp,
                                Exobs: this.movimientosData[i].Exobs,
                                Uslogin: this.movimientosData[i].Uslogin,
                            });
                            if((this.movimiento[i].Exresp == "S " ) || (this.movimiento[i].Exresp == "s " )){
                                this.movimiento[i].Exresp = 'SI'
                            }else if ((this.movimiento[i].Exresp == "N " ) || (this.movimiento[i].Exresp == "n " )){
                                this.movimiento[i].Exresp = 'NO'
                            }
                        }
                    }
                    this.datos = this.movimiento;
                })
            },
        },

    }

</script>
<style>
    .v-data-table-header {
        font-weight: bold;
        background-color: success;
    }
    #titulocard{
        color: white;
    }
    
</style>